import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';
import { userInfoAtom } from '../../../../../data/atoms/utilsAtoms';
import checkApiStatus from '../../../../../component/SubscripStatus';
import api from '../../../../../data/api';
import axios from 'axios';

const TopBar = ({ title = 'Pick Your Plan' }) => {
	const userData = useAtomValue(userInfoAtom);
	const setUserData = useSetAtom(userInfoAtom);

	useEffect(() => {
		const intervalId = setInterval(async () => {
			checkApiStatus(userData.token, setUserData);

			const userId = userData.user?.userId ?? userData?.user?._id;
			if (!userId) {
				return;
			}
			const response = await api.getPersonalInformation(userId);

			setUserData({
				...userData,
				user: {
					...userData.user,
					userType: response?.data?.userType
				}
			});
			localStorage.setItem('userData', JSON.stringify(userData.user));
		}, 5000); // 5000 milliseconds = 5 seconds

		// Cleanup function to clear the interval when the component is unmounted or dependencies change
		return () => clearInterval(intervalId);
	}, [setUserData, userData.user?.toString(), userData.token]);

	axios.defaults.withCredentials = true;
	return (
		<>
			<div className="container-c-section">
				{userData.token ? (
					<div className="c-join-section text-white pt-1 pt-lg-0 top-bar-font">
						{userData.token ? `Welcome, ${userData.user.firstname} ${userData.user.lastname}.` : ''}
					</div>
				) : (
					<div className="c-join-section pt-1 pt-lg-0 text-white top-bar-font">Join The Community and Access Exclusive Content</div>
				)}
			</div>
			<div className="c-tab_cata-text c-plane_page-m">
				<h1>{title}</h1>
			</div>
		</>
	);
};

export default TopBar;
